<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-end">
      <b-form-select class="my-3 col-md-2 mx-2" v-model="email_filter_selected" :options="email_filter_options" @input="searchTemplate"></b-form-select>
      <search-items v-model="params.search" :searchHandler="searchTemplate" :placeholder="'Type to search'"></search-items>
    </div>
    <b-table  sort-icon-left
        :items="email_templates"
        :fields="headers"
        @sort-changed="sortingChanged"
    >
      <template #cell(is_active)="{item}" v-if="$can('active-inactive-email-template')">
        <b-form-checkbox v-model="item.is_active" name="check-button" @change="updateEmailTemplate(item)" switch></b-form-checkbox>
      </template>
      <template #cell(actions)="item">
        <edit class="delete_step ml-2" @click="editEmailTemplate(item)" fillColor="#009FE3"/>
      </template>
    </b-table>

    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
        :key="pagination.currentPage"
    ></b-pagination>

    <b-modal id="addTemplateModal" size="lg" no-close-on-backdrop  hide-footer @close="handleModalCloseEvent">
      <template #modal-title>
        <span>Email Template</span>
      </template>
      <template v-if="active_template">
        <div class="row">
          <div class="col-md-6">
            <b-form-group
                label="Title"
                labelClass="required"
            >
              <b-form-input
                  type="text"
                  placeholder="Title"
                  v-model="active_template.email_title"
                  name="title"
                  v-validate="{required: true}"
              ></b-form-input>
              <div v-if="errors && errors.first('title')" class="error_msg">
                The title field is required
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
                label="Email Type"
                labelClass="required"
            >
              <b-form-input
                  type="text"
                  placeholder="Title"
                  :value="active_template.email_type"
                  name="title"
                  :readonly="true"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
                label="Email Subject"
                labelClass="required"
            >
              <b-form-input
                  type="text"
                  placeholder="Subject"
                  v-model="active_template.email_subject"
                  name="subject"
                  v-validate="{required: true}" ref="email_subject_input"
                  @focus="enable_subject_tags = true" @blur="handleEmailSubjectInputBlurEvent" autocomplete="off"
              ></b-form-input>
              <div v-if="errors && errors.first('subject')" class="error_msg">
                {{ errors.first('subject') }}
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <b-form-group
                label="Subject Tags"
                labelClass="required"
            >
              <b-button  :disabled="!enable_subject_tags"  class="mr-2 mb-2" :key="tag.value" v-for="(tag) in active_template.tags.subject_tags" variant="primary"
                        @click="addTag('email_subject', tag)">
                {{tag.text}}
              </b-button>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
                label="Body Tags"
                labelClass="required"
            >
              <b-button :disabled="tagsButtonDisable"  class="mr-2 mb-2" :key="tag.value" v-for="(tag) in active_template.tags.body_tags" variant="primary"
                        @click="addTag('email_body',tag)">
                {{tag.text}}
              </b-button>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group id="email_content" label-for="content">
              <label class="required">Email Content</label>
              <vue-editor @focus="enableTags()" @blur="disableTags()" id="tag_text" v-model="active_template.email_body" name="content"
                          v-validate="{required: true}"
                          useCustomImageHandler
                          @image-added="handleImageAdded"
                          :editorToolbar="customToolbar"
                          ref="email_body_input"></vue-editor>
              <div v-if="errors && errors.first('content')" class="error_msg">
                The content field is required
              </div>
            </b-form-group>
          </div>
          <div class="col-12 text-right mt-3">
            <b-button variant="primary" @click="updateEmailTemplate(null)">Save</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete';
import Edit from 'vue-material-design-icons/CircleEditOutline';
import { VueEditor } from "vue2-editor";
import { http } from "@/config/httpCommon"
import {
  handleResponseException, santaClone, setPageModal
} from "@/helpers/Helpers";
import SearchItems from "@/components/SearchItems.vue";
import {trimEnd, trimStart} from "lodash";

const customToolBar = [[{
  header: [false, 1, 2, 3, 4, 5, 6]
  }], ["bold", "italic", "underline", "strike"], // toggled buttons
  [{
    align: ""
  }, {
    align: "center"
  }, {
    align: "right"
  }, {
    align: "justify"
  }], ["blockquote"], [{
    list: "ordered"
  }, {
    list: "bullet"
  }, {
    list: "check"
  }], [{
    indent: "-1"
  }, {
    indent: "+1"
  }], // outdent/indent
  [{
    color: []
  }, {
    background: []
  }], // dropdown with defaults from theme
  ["link", "image"], ["clean"] // remove formatting button
]
export default {
  components: {
    Edit,
    VueEditor,
    SearchItems,
  },
  async created(){
    this.$store.commit('set', ['showLoader', true]);
    this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getEmailTemplates)
    this.$store.commit('set', ['showLoader', false]);
  },
  mounted() {
    this.headers = [
      {key: 'email_title', label: 'Title',sortable: true},
      {key: 'email_subject', label: 'Subject',sortable: true},
      {key: 'email_type', label: 'Type',sortable: true},
    ]
    if(this.$can('active-inactive-email-template')) {
      this.headers.push( {key: 'is_active', label: 'Active',sortable: true})
    }
    console.log(this.$refs["email_body_input"])
    this.headers.push({key: 'actions', label: 'Actions',sortable: false})
  },
  data() {
    return {
      fields: [],
      active_template: null,
      active_template_index: null,
      checkbox: [],
      base_url: process.env.VUE_APP_FILE_URL,
      headers: [],
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      sorting_obj: {},
      sort_by: 'email_title', //Field key for sorting by (or null for no sorting
      sortDesc: true,
      params: {
        sort_by: 'id', //Field key for sorting by (or null for no sorting
        sort_order: "DESC", // true if sorting descending, false otherwise
        search:'',
        page : 1,
        get_email_types: true
      },
      tags : [
        {text:'Locker Name', value: '||locker_name||'},
        {text:'Due Date', value: '||due_date||'},
        {text:'Description', value: '||description||'},
        {text:'Link', value: '{||Click here||}'},
      ],
      email_filter_options :[],
      email_filter_selected: '',
      tagsButtonDisable : true,
      enable_subject_tags: false,
      enable_body_tags: false,
      email_types: [],
      email_tags: [],
      email_templates: [],
      file_size: 1024 * 1024 * 2,

      customToolbar: customToolBar
    }
  },
  methods:{
    sortingChanged(sorting_obj) {
      this.sorting_obj = {
        sort_by: sorting_obj.sortBy, sort_order: sorting_obj.sortDesc ? "DESC" : "ASC"
      };
      this.getEmailTemplates()
    },
    searchTemplate(){
      this.params.page = 1;
      setPageModal(1,this.$route.name,this.params);
      this.getEmailTemplates();
    },
    async getEmailTemplates() {
      this.$store.commit('set', ['showLoader', true]);
      //make params
      if(Object.keys(this.sorting_obj).length > 0) {
        this.params.sort_by = this.sorting_obj.sort_by
        this.params.sort_order = this.sorting_obj.sort_order
      }
      if(this.params.email_types) {
        this.params.get_email_types = true;
      }
      this.params.emails_for = this.email_filter_selected
      let params = new URLSearchParams(this.params);
      params = '?'+params.toString();
      setPageModal(this.params.page,this.$route.name,this.params);
      http.get(`email-templates`+params).then(successResponse => {
        const {data: {success, result: { email_templates, email_templates_filter_options }}} = successResponse
        this.email_templates = email_templates.data;
        this.email_filter_options = email_templates_filter_options
        this.makePagination(email_templates);
      }).catch(errorResponse => {
        handleResponseException(errorResponse)
      });
      this.params.get_email_types = false;
      this.$store.commit('set', ['showLoader', false]);
    },
    async handlePagination(page=''){
      this.params.page = page
      setPageModal(page,this.$route.name,this.params);
      await this.getEmailTemplates();
    },
    makePagination(data){
      this.pagination.currentPage = data.current_page;
      this.pagination.rows = data.total;
      this.pagination.perPage = data.per_page;
      this.pagination.total = data.total;
    },
    async updateEmailTemplate(email_template = null) {
      let email_template_form_validated = true
      let active_template = this.active_template
      //if email template given then no need to validate form. In that case user want to do inline operations like active/de-active template
      if(email_template) {
        active_template = email_template
      } else {
        email_template_form_validated = await this.$validator.validate();
      }
      if(email_template_form_validated) {
        http.patch(`email-templates/${active_template.id}`, {email_template: active_template}).then(successResponse => {
          const {data: {message, result: {updated_email_template}} } = successResponse
          const update_active_template = email_template ? email_template : this.email_templates[this.active_template_index]
          update_active_template.id = updated_email_template.id;
          update_active_template.company_id = updated_email_template.company_id;
          update_active_template.is_active = updated_email_template.is_active;
          if(email_template === null) {
            update_active_template.email_title = updated_email_template.email_title;
            update_active_template.email_subject = updated_email_template.email_subject;
            update_active_template.email_body = updated_email_template.email_body;
            this.$bvModal.hide("addTemplateModal");
          } else {
            this.active_template = null
          }
          this.showToast(message,'SUCCESS')
        }).catch(errorResponse => {
          handleResponseException(errorResponse)
        });
      }
    },
    async editEmailTemplate(email_template_info_obj){
      this.active_template_index = email_template_info_obj.index;
      this.active_template = santaClone(email_template_info_obj.item);
      this.$bvModal.show("addTemplateModal");
    },
    addTag(tag_for, tag) {
      const tag_target_element = tag_for === "email_subject" ? this.$refs.email_subject_input : this.$refs.email_body_input;
      const target_content = tag_for === "email_subject" ? this.active_template?.email_subject : this.active_template?.email_body
      if(tag_for === "email_subject") {
        const cursor_position = tag_target_element.selectionStart;
        const tag_prefix = trimEnd(target_content.substring(0, cursor_position));
        const tag_postfix = trimStart(target_content.substring(cursor_position));
        const tag_value = ` ${tag.value} `
        this.active_template.email_subject = `${tag_prefix}${tag_value}${tag_postfix}`
        window.getSelection().removeAllRanges()
        setTimeout(() => {
          const cursor_index = `${tag_prefix}${tag_value}`.length
          tag_target_element.focus()
          this.enable_subject_tags = true;
          tag_target_element.setSelectionRange(cursor_index, cursor_index);
          }, 300)
      } else {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          if(range) {
            const new_tag = document.createElement("span");
            new_tag.textContent = ` ${tag.value} `;
            range.deleteContents()
            range.insertNode(new_tag)
            selection.removeAllRanges();
          }
        }
      }
    },
    enableTags(){
      this.tagsButtonDisable = false
    },
    disableTags(){
      this.tagsButtonDisable = true
    },
    handleEmailSubjectInputBlurEvent() {
      setTimeout(() => {
        this.enable_subject_tags = false;
      }, 200)
    },
    handleModalCloseEvent() {
      this.active_template = null
      this.active_template_index = null
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      // Check file size
      if (file.size > this.file_size) { // Limit to 2MB
        this.showToast('Image size exceeds 2MB limit.','error');
        return;
      }
      // Create a data URL for the image
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const dataURL = reader.result;

        // Insert the image using the data URL
        Editor.insertEmbed(cursorLocation, 'image', dataURL);
        resetUploader();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.add_field_btn{
  width: 125px;
  .float-right{
    line-height: 0;
  }
}
.delete_addons, .edit_addons{
  cursor: pointer;
}
.img-thumbnail{
  width: 200px;
}
</style>
